import { AgenteEndereco } from './../../../../services/pesados-brasil/agente-endereco.interface';
import { PesadosBrasilStorage } from './../../../../services/pesados-brasil/pesados-brasil.storage';
import { Component, OnInit, Output, ViewChild, EventEmitter } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-modal-pesados-brasil',
  templateUrl: './modal-pesados-brasil.component.html',
  styleUrls: ['./modal-pesados-brasil.component.scss']
})
export class ModalPesadosBrasilComponent implements OnInit {

  @Output() confirmarEventEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Output() cancelarEventEmitter: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('modal', { static: true }) public modal: ModalDirective;

  public agenteEndereco: AgenteEndereco;

  constructor(private pesadosBrasilStorage: PesadosBrasilStorage) { }

  ngOnInit() {
    this.agenteEndereco = this.pesadosBrasilStorage.agenteEndereco;
  }

  show() {
    this.modal.show();
  }

  hide() {
    this.modal.hide();
  }

  confirmar() {
    this.confirmarEventEmitter.emit();
    this.hide();
  }

  cancelar() {
    this.cancelarEventEmitter.emit();
    this.hide();
  }
}
